// NOTE mainly based on https://codepen.io/ssk7833/details/mVOXXp/
import { APP_CONSTANTS } from '../projects/common/app/app.constants';

// get current script tag
const script = <HTMLScriptElement>document.currentScript;
const segmentReleaseEnv = '/p/geoloketlb/web';
const segmentRoute = '/embedded/kaart';
const pathArray = script.src.split('/');
const protocol = pathArray[0];
const host = pathArray[2];
// define URL which is different for localhost environment
const url = host.toLowerCase().startsWith('localhost') ? `${protocol}//${host}${segmentRoute}` : `${protocol}//${host}${segmentReleaseEnv}${segmentRoute}`;

// make the iframe
const iframe = <HTMLIFrameElement>document.createElement('iframe');
iframe.src = url;
iframe.setAttribute('style', 'width:100%;height:100%;border:0');
// append the iframe in the parent of the script tag
script.parentNode.appendChild(iframe);

/**
 * Fullscreen is supported by the current platform.
 */
function isFullScreenSupported() {
    const doc = <any>document;
    const body = <any>document.body;
    return !!(
        body.webkitRequestFullscreen ||
        (body.mozRequestFullScreen && doc.mozFullScreenEnabled) ||
        (body.msRequestFullscreen && doc.msFullscreenEnabled) ||
        (document.body.requestFullscreen && document.fullscreenEnabled)
    );
}

/**
 * Element is currently in fullscreen.
 *
 * @param element  Chech whether this element is the full-screen element. If ommited, this will simply return if any DOM (or shadow DOM) node is full-screen.
 */
function isFullScreen(element?: Element) {
    const doc = <any>document;
    let isFullScreen = !!(doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement || document.fullscreenElement);
    if (isFullScreen && element) {
        const currentElement = doc.msFullscreenElement || document.fullscreenElement;
        if (currentElement) {
            // only able to check properly when the browser API supports checking the element, otherwise ignore check
            isFullScreen = currentElement == element;
        }
    }
    return isFullScreen;
}

/**
 * Request to fullscreen an element.
 *
 * @param element  Element to request fullscreen
 */
function requestFullScreen(element: Element): Promise<void> {
    const el = <any>element;
    if (element.requestFullscreen) {
        return element.requestFullscreen();
    } else if (el.msRequestFullscreen) {
        return el.msRequestFullscreen();
    } else if (el.mozRequestFullScreen) {
        return el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
        return el.webkitRequestFullscreen();
    }
}

/**
 * Exit fullscreen.
 */
function exitFullScreen(): Promise<void> {
    const doc = <any>document;
    if (document.exitFullscreen) {
        return document.exitFullscreen();
    } else if (doc.msExitFullscreen) {
        return doc.msExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
        return doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
        return doc.webkitExitFullscreen();
    }
}

/**
 * Get name of fullscreen event
 * @private
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getFullScreenEventName() {
    const body = <any>document.body;
    if (document.body.requestFullscreen && document.fullscreenEnabled) {
        return 'fullscreenchange';
    } else if (body.msRequestFullscreen && (<any>document).msFullscreenEnabled) {
        return 'MSFullscreenChange';
    } else if (body.mozRequestFullScreen && (<any>document).mozFullScreenEnabled) {
        return 'mozfullscreenchange';
    } else if (body.webkitRequestFullscreen) {
        return 'webkitfullscreenchange';
    }
}

// detect enter or exit fullscreen mode
document.addEventListener('webkitfullscreenchange', fullscreenChange);
document.addEventListener('mozfullscreenchange', fullscreenChange);
document.addEventListener('fullscreenchange', fullscreenChange);
document.addEventListener('MSFullscreenChange', fullscreenChange);

function fullscreenChange() {
    if (isFullScreen()) {
        //console.log('enter fullscreen');
    } else {
        //console.log('exit fullscreen');
        // in case escape is pressed we need to force geoloket embedded to change the fullscreen variable
        const msg = {
            source: APP_CONSTANTS.AppBui,
            action: 'fullscreen',
            value: false
        };
        iframe.contentWindow.postMessage(msg, '*');
    }
}

function fullscreen() {
    // check if fullscreen mode is available
    if (isFullScreenSupported()) {
        // which element will be fullscreen
        // Do fullscreen
        requestFullScreen(iframe);
    } else {
        document.querySelector('.error').innerHTML = 'Your browser is not supported';
    }
}

function bindEvent(element: any, eventName: any, eventHandler: any): void {
    if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
    }
}

function handleMessage(e: any) {
    if (e != null && e.data != null && e.data.source == APP_CONSTANTS.AppBui) {
        switch (e.data.action) {
            case 'fullscreen': {
                if (e.data.value) {
                    fullscreen();
                } else {
                    exitFullScreen();
                }
            }
        }
    }
}

bindEvent(window, 'message', (e: any) => handleMessage(e));
